import { createContext, useContext } from "react";

export const SiteVarsContext = createContext(null);